<template>
  <section :class="$style.container" data-luko-tracking="TextIconSection">
    <Wrapper :class="$style.inner">
      <div :class="$style.desc">
        <Title
          :class="$style.contentTitle"
          is-large-title
          :title-params="content.title"
        />
        <RichText :text-params="content.text" :class="$style.description" />
        <PLink
          v-if="content.link_text"
          :link-object="content.link_url"
          is-highlight
          color="bluko"
        >
          {{ content.link_text }}
        </PLink>
      </div>
      <div :class="$style.view">
        <ul :class="$style.iconsList">
          <li
            v-for="(item, itemIndex) in items"
            :key="itemIndex"
            :class="$style.iconBlock"
            data-aos="zoom-in"
            :data-aos-delay="randomDelay"
            data-aos-duration="300"
          >
            <a
              v-if="item.link && item.link.url"
              :href="item.link.url"
              :class="[$style.iconBox, $style.iconLink]"
            >
              <PImage
                :image-object="item.icon"
                :class="[$style.icon, { [$style.isTwo]: isTwo }]"
              />
              <p :class="[$style.label, { [$style.isTwo]: isTwo }]">
                {{ item.label }}
              </p>
              <p
                v-if="item.sublabel"
                :class="[$style.sublabel, { [$style.isTwo]: isTwo }]"
              >
                {{ item.sublabel }}
              </p>
            </a>
            <div v-else :class="$style.iconBox">
              <PImage
                :image-object="item.icon"
                :class="[$style.icon, { [$style.isTwo]: isTwo }]"
              />
              <p :class="[$style.label, { [$style.isTwo]: isTwo }]">
                {{ item.label }}
              </p>
              <p
                v-if="item.sublabel"
                :class="[$style.sublabel, { [$style.isTwo]: isTwo }]"
              >
                {{ item.sublabel }}
              </p>
            </div>
          </li>
        </ul>
        <RichText
          :text-params="content.icons_subtext"
          :class="$style.iconsSubtext"
        />
      </div>
    </Wrapper>
  </section>
</template>

<script>
import RichText from '~/components/RichText'
import Title from '~/components/Title'
import PImage from '~/components/PImage'
import PLink from '~/components/PLink'

export default {
  name: 'TextIconSection',

  components: {
    RichText,
    Title,
    PImage,
    PLink,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      sliceItemRange: new Array(this.slice.items.length)
        .fill(0)
        .map((i, idx) => idx),
      items: this.slice.items,
      content: this.slice.primary,
      isTwo: this.slice.items.length === 2,
    }
  },

  computed: {
    randomDelay() {
      const rIdx = Math.floor(Math.random() * this.sliceItemRange.length)
      return (this.sliceItemRange.splice(rIdx, 1)[0] + 1) * 100
    },
  },
}
</script>

<style lang="scss" module>
.container {
  padding: 0 24px;
}

.inner {
  margin: 128px auto;

  @include above(medium) {
    display: flex;
    align-items: center;
    justify-content: space-between;

    column-gap: 24px;

    @include above(small) {
      column-gap: 32px;
    }
    @include above(large) {
      column-gap: 40px;
    }
  }
}

.desc {
  flex-basis: 0;
  flex-grow: 1;

  a {
    margin-top: 40px;
  }

  @include above(small) {
    margin-top: 0;
  }

  @include above(medium) {
    max-width: 474px;
    margin: 0 73px;
  }
}

.description {
  margin-top: 16px;

  color: $gray-700;
}

.view {
  flex-basis: 0;
  flex-grow: 1;
  margin-top: 40px;

  @include above(medium) {
    max-width: 620px;
    margin-top: 0px;
  }
}

.iconsList {
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  justify-content: space-between;
}

.iconBlock {
  flex-basis: calc(50% - 40px);
  flex-grow: 1;

  text-align: center;

  &:nth-child(n + 5) {
    display: none;
  }

  @include above(small) {
    flex-basis: calc(33% - 40px);
    &:nth-child(n + 5) {
      display: block;
    }
  }
}

.icon {
  height: 48px;
}
.icon.isTwo {
  height: 150px;
  @include below(small) {
    height: 80px;
  }
}

.iconLink {
  text-decoration: none;
  &:hover {
    box-shadow: 0px 0px 5px #2c23021f;
    transform: translateY(-2px);
  }
}
.iconBox {
  display: inline-block;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  border-radius: 8px;
}

.label {
  margin-top: 16px;

  color: $gray-1000;
}
.label.isTwo {
  color: $gray-1000;

  @include above(small) {
    @include typo-headline-bold;
    color: $gray-1000;
  }
}

.sublabel {
  @include typo-sub-text;
  margin-top: 4px;

  color: $gray-500;
}
.sublabel.isTwo {
  margin-top: 4px;

  color: $gray-500;

  @include above(small) {
    @include typo-headline;
    color: $gray-500;
  }
}

.iconsSubtext {
  margin-top: 40px;

  p {
    @include typo-sub-text;
    color: $gray-700;

    text-align: center;
  }
}
</style>
